var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import client from "../http/client";
var USE_HARDCODED_DATA = false;
var EMPTY_MARKETING_DATA = {
    marketingMenuItems: [],
    marketingDisplayItems: [],
    menuUpsellItems: [],
};
var EMPTY_SPECIALS = [];
var HARDCODED_MARKETING_DATA = {
    marketingMenuItems: [
        {
            posMenuId: 462,
            startsAt: "2026-03-30",
            expiresAt: "2026-04-01",
            marketingText: "Add a sauce cup",
            backgroundColor: "#355872",
            fontColor: "#ffffff",
            borderColor: "na",
            showBorder: false,
        },
        {
            posMenuId: 50184,
            startsAt: "2026-03-30",
            expiresAt: "2026-04-02",
            marketingText: "Perfect for breadsticks",
            backgroundColor: "#355872",
            fontColor: "white",
            borderColor: "na",
            showBorder: false,
        },
    ],
    marketingDisplayItems: [
        {
            assetUrl: "https://img.freepik.com/premium-vector/welcome-back-handwriting-white-background-vector-illustration_788759-3344.jpg?semt=ais_hybrid&w=740&q=80",
            width: 1080,
            height: 1920,
            expiresAt: "",
            startsAt: "2026-03-11",
            displayTitle: "Welcome Back!",
            displayText: "Check out our featured favorites today.",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "Start Order",
            ctaType: "order",
            priority: 1,
            duration: 3500,
            ctaItem: "",
        },
        {
            assetUrl: "https://s3.us-east-2.amazonaws.com/arrowpos-menu-images/9ca89c69-9c0f-40e9-aba2-9b1948793e35.jpg",
            width: 1080,
            height: 1920,
            expiresAt: "2026-04-24",
            startsAt: "2026-03-01",
            displayTitle: "Dipping Sauces",
            displayText: "Add a sauce cup to complete your order.",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "Learn More",
            ctaType: "category",
            priority: 2,
            duration: 3500,
            ctaItem: 50179,
        },
        {
            assetUrl: "https://png.pngtree.com/png-clipart/20220123/original/pngtree-sign-up-now-png-image_7152614.png",
            width: 1080,
            height: 1920,
            startsAt: "2026-04-02",
            expiresAt: null,
            displayTitle: "Sign up today",
            displayText: "Dont miss out on rewards!",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            priority: 3,
            displayCtaButton: true,
            ctaType: "accountSignUp",
            ctaItem: "",
            ctaButtonText: "Sign up now",
            duration: 3500,
        },
        {
            assetUrl: "https://dijf55il5e0d1.cloudfront.net/images/na/7/2/8/72831_1000.jpg",
            width: 1080,
            height: 1920,
            startsAt: "2026-04-02",
            expiresAt: null,
            displayTitle: "10% off",
            displayText: "click to add promotion",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            priority: 4,
            displayCtaButton: true,
            ctaType: "promotion",
            ctaItem: "",
            promotionCode: "10OFF",
            ctaButtonText: "Click to add",
            duration: 3500,
        },
        {
            assetUrl: "https://thumbs.dreamstime.com/b/free-delivery-man-riding-scooter-man-courier-riding-scooter-parcel-box-fast-delivery-concept-free-delivery-man-riding-162009472.jpg",
            width: 1080,
            height: 1350,
            expiresAt: "2026-05-18",
            startsAt: "2026-04-02",
            displayTitle: "Free Delivery",
            displayText: "Placeholder promo card for checkout testing.",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "View Deals",
            ctaType: "deals",
            priority: 5,
            duration: 3500,
            ctaItem: "",
        },
        {
            assetUrl: "https://s3.us-east-2.amazonaws.com/arrowpos-menu-images/6010de97962146d395570186400e18a0.jpg",
            width: 1200,
            height: 628,
            expiresAt: "2026-05-23",
            startsAt: "2026-04-11",
            displayTitle: "Limited Time",
            displayText: "Try our Fabulous Four ",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "See Special",
            ctaType: "item",
            priority: 6,
            ctaItem: 50343,
            duration: 3500,
        },
        {
            assetUrl: "https://s3.us-east-2.amazonaws.com/arrowpos-menu-images/6010de97962146d395570186400e18a0.jpg",
            width: 1200,
            height: 628,
            expiresAt: "2026-03-29",
            startsAt: "2027-03-03",
            displayTitle: "Fan Favorite!",
            displayText: "Try Chicago Deep Dish",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "Order it!",
            ctaType: "item",
            priority: 7,
            ctaItem: 148,
            duration: 3500,
        },
        {
            assetUrl: "https://s3.us-east-2.amazonaws.com/arrowpos-menu-images/6010de97962146d395570186400e18a0.jpg",
            width: 1200,
            height: 628,
            expiresAt: "2026-04-23",
            startsAt: "2026-03-03",
            displayTitle: "Limited Time",
            displayText: "Try our Fabulous Four ",
            displayAtCheckout: false,
            displayAtHomeScreen: false,
            displayCtaButton: true,
            ctaButtonText: "See Special",
            ctaType: "item",
            priority: 8,
            ctaItem: 50343,
            duration: 3500,
        },
    ],
    menuUpsellItems: [
        {
            description: "Favorite!",
            priority: 1,
            soldMenuItemId: 148,
            upsellMenuItemId: 109,
            upsellOnAllMenuItems: false,
            expiresAt: null,
            startsAt: "2026-03-30",
        },
        {
            description: "Healthy",
            priority: 1,
            soldMenuItemId: null,
            upsellMenuItemId: 123,
            upsellOnAllMenuItems: true,
            expiresAt: null,
            startsAt: "2026-03-30",
        },
        {
            description: "New!",
            priority: 1,
            soldMenuItemId: null,
            upsellMenuItemId: 240,
            upsellOnAllMenuItems: true,
            expiresAt: null,
            startsAt: "2026-03-30",
        },
        {
            description: "Thirsty?",
            priority: 1,
            soldMenuItemId: null,
            upsellMenuItemId: 964,
            upsellOnAllMenuItems: true,
            expiresAt: null,
            startsAt: "2026-03-30",
        },
    ],
};
var MarketingContext = createContext(undefined);
var normalizeDateValue = function (dateValue) {
    if (typeof dateValue !== "string") {
        return null;
    }
    var trimmedDate = dateValue.trim();
    return trimmedDate.length > 0 ? trimmedDate : null;
};
var isWithinVisibilityWindow = function (item) {
    var startsAt = normalizeDateValue(item.startsAt);
    var expiresAt = normalizeDateValue(item.expiresAt);
    var now = new Date();
    if (startsAt) {
        var startsAtDate = new Date(startsAt);
        if (Number.isNaN(startsAtDate.getTime()) || now < startsAtDate) {
            return false;
        }
    }
    if (expiresAt) {
        var expiresAtDate = new Date(expiresAt);
        if (Number.isNaN(expiresAtDate.getTime())) {
            return false;
        }
        expiresAtDate.setHours(23, 59, 59, 999);
        if (now > expiresAtDate) {
            return false;
        }
    }
    return true;
};
var normalizeMarketingPayload = function (input) {
    if (!input || typeof input !== "object") {
        return EMPTY_MARKETING_DATA;
    }
    var payload = input;
    var marketingMenuItems = Array.isArray(payload.marketingMenuItems) ? payload.marketingMenuItems : [];
    var marketingDisplayItems = Array.isArray(payload.marketingDisplayItems) ? payload.marketingDisplayItems : [];
    var menuUpsellItems = Array.isArray(payload.menuUpsellItems) ? payload.menuUpsellItems : [];
    return {
        marketingMenuItems: marketingMenuItems.filter(function (item) { return isWithinVisibilityWindow(item); }),
        marketingDisplayItems: marketingDisplayItems.filter(function (item) { return isWithinVisibilityWindow(item); }),
        menuUpsellItems: menuUpsellItems.filter(function (item) { return isWithinVisibilityWindow(item); }),
    };
};
var normalizeSpecial = function (input) {
    var _a, _b, _c;
    if (!input || typeof input !== "object") {
        return null;
    }
    var special = input;
    var id = Number(special.id);
    var storeId = Number(special.store_id);
    var name = String(special.name || "").trim();
    if (!Number.isFinite(id) || !Number.isFinite(storeId) || !name) {
        return null;
    }
    var firstPage = special.first_page === null || special.first_page === undefined
        ? null
        : Number(special.first_page);
    var sortOrder = special.sort_order === null || special.sort_order === undefined
        ? null
        : Number(special.sort_order);
    return {
        id: id,
        first_page: firstPage !== null && Number.isFinite(firstPage) ? firstPage : null,
        store_id: storeId,
        name: name,
        description: String(special.description || "").trim(),
        display_in_specials: (_a = special.display_in_specials) !== null && _a !== void 0 ? _a : false,
        enabled: (_b = special.enabled) !== null && _b !== void 0 ? _b : false,
        start_time: String(special.start_time || ""),
        end_time: String(special.end_time || ""),
        imageURL: String(special.imageURL || "").trim(),
        has_overall_discount: (_c = special.has_overall_discount) !== null && _c !== void 0 ? _c : false,
        discount_value: Number(special.discount_value) || 0,
        discount_type: String(special.discount_type || ""),
        max_discount: Number(special.max_discount) || 0,
        available_days: String(special.available_days || ""),
        sort_order: sortOrder !== null && Number.isFinite(sortOrder) ? sortOrder : null,
        catering_menu_availability: special.catering_menu_availability === "catering" || special.catering_menu_availability === "both"
            ? special.catering_menu_availability
            : "not_catering",
        pages: Array.isArray(special.pages) ? special.pages : [],
    };
};
var normalizeSpecials = function (input) {
    if (!Array.isArray(input)) {
        return EMPTY_SPECIALS;
    }
    return input
        .map(function (special) { return normalizeSpecial(special); })
        .filter(function (special) { return special !== null; });
};
var getMarketingUrl = function () {
    var _a;
    var globalSession = window.session;
    var appId = (_a = globalSession === null || globalSession === void 0 ? void 0 : globalSession.store) === null || _a === void 0 ? void 0 : _a.app_id;
    var normalizedAppId = typeof appId === "string" ? String(appId) : "";
    if (normalizedAppId.length > 1) {
        return "https://arrow-magic-json.s3.us-east-2.amazonaws.com/magicJson-".concat(normalizedAppId, ".json");
    }
};
export var MarketingProvider = function (_a) {
    var children = _a.children;
    var _b = useState(EMPTY_MARKETING_DATA), marketingData = _b[0], setMarketingData = _b[1];
    var _c = useState(EMPTY_SPECIALS), specials = _c[0], setSpecials = _c[1];
    var _d = useState(true), isLoadingMarketing = _d[0], setIsLoadingMarketing = _d[1];
    var _e = useState(true), isLoadingSpecials = _e[0], setIsLoadingSpecials = _e[1];
    var _f = useState(null), marketingError = _f[0], setMarketingError = _f[1];
    var _g = useState(null), specialsError = _g[0], setSpecialsError = _g[1];
    var refreshMarketing = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var marketingUrl, response, normalizedPayload, _error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingMarketing(true);
                    if (USE_HARDCODED_DATA) {
                        setMarketingData(normalizeMarketingPayload(HARDCODED_MARKETING_DATA));
                        setMarketingError(null);
                        setIsLoadingMarketing(false);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    marketingUrl = getMarketingUrl();
                    if (!marketingUrl) {
                        setMarketingData(EMPTY_MARKETING_DATA);
                        setMarketingError(null);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, axios.get(marketingUrl)];
                case 2:
                    response = _a.sent();
                    normalizedPayload = normalizeMarketingPayload(response.data);
                    setMarketingData(normalizedPayload);
                    setMarketingError(null);
                    return [3 /*break*/, 5];
                case 3:
                    _error_1 = _a.sent();
                    setMarketingError("Unable to load marketing data.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingMarketing(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var refreshSpecials = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, normalizedSpecials, _error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoadingSpecials(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client.get("/menu/specials/api")];
                case 2:
                    response = _a.sent();
                    normalizedSpecials = normalizeSpecials(response.data);
                    setSpecials(normalizedSpecials);
                    setSpecialsError(null);
                    return [3 /*break*/, 5];
                case 3:
                    _error_2 = _a.sent();
                    setSpecials(EMPTY_SPECIALS);
                    setSpecialsError("Unable to load specials.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadingSpecials(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        refreshMarketing().catch(function () {
            setIsLoadingMarketing(false);
            setMarketingError("Unable to load marketing data.");
        });
        refreshSpecials().catch(function () {
            setIsLoadingSpecials(false);
            setSpecials(EMPTY_SPECIALS);
            setSpecialsError("Unable to load specials.");
        });
    }, [refreshMarketing, refreshSpecials]);
    var value = useMemo(function () { return ({
        marketingData: marketingData,
        specials: specials,
        isLoadingMarketing: isLoadingMarketing,
        isLoadingSpecials: isLoadingSpecials,
        marketingError: marketingError,
        specialsError: specialsError,
        refreshMarketing: refreshMarketing,
        refreshSpecials: refreshSpecials,
    }); }, [isLoadingMarketing, isLoadingSpecials, marketingData, marketingError, refreshMarketing, refreshSpecials, specials, specialsError]);
    return (React.createElement(MarketingContext.Provider, { value: value }, children));
};
export var useMarketing = function () {
    var context = useContext(MarketingContext);
    if (!context) {
        throw new Error("useMarketing must be used within a MarketingProvider");
    }
    return context;
};
